<template>
  <div class="row col-12">
    <div class="col">
      <div class="text-brand-1 text-weight-bold">{{ label }}</div>
      <q-select
        dense
        outlined
        :label="placeholder"
        hide-bottom-space
        :options="options"
        option-label="label"
        option-value="value"
        map-options
        v-model="valor"
        :rules="[(val) => !!val || validateMessage]"
      />
    </div>
  </div>
</template>

<script>
import { ref, watch } from "vue";

export default {
  name: "ComponentTypeSelect",
  emits: ["enviarValor"],
  props: {
    name: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: undefined,
    },
    label: {
      type: String,
    },
    value: {
      type: Object || undefined,
      default: undefined,
    },
    validateMessage: {
      type: String,
      default: "Campo obrigatório",
    },
    required: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
      default: undefined,
    },
  },
  setup(props, { emit }) {
    const valor = ref(props.value);

    watch(
      () => props.value,
      () => {
        if (valor.value === props.value) {
          return;
        }
        valor.value = props.value;
      }
    );

    watch(
      () => valor.value,
      () => {
        emit("enviarValor", { value: valor.value, name: props.name });
      }
    );

    return { valor };
  },
};
</script>
